import Component from "../lib/Component";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class Anchor extends Component {
  mount({ root }) {
    console.log(root)
    // const element = document.querySelector(`[data-anchor="${root.getAttribute("href")}"]`);
    this.listener = (e) => {

      // e.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: { y: window.innerHeight }, ease: "Power1.easeInOut" });
    };

    root.addEventListener("click", this.listener);
  }

  unmount({ root }) {
    this.listener && root.removeEventListener(this.listener);
  }
}
